<app-italo-ecu-logo></app-italo-ecu-logo>

<div id="tuning-configurator"></div>

<app-language-switcher></app-language-switcher>
<app-navigation></app-navigation>
